import { Box, Grid, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import * as React from "react";
import { makeStyles } from "@mui/styles";
import Banner from "../../Assets/Images/academicProgramBannerBg.png";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useBack } from "use-back";
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import Back from '../../Assets/Svg/back.svg';

const useStyles = makeStyles((theme) => ({
	banner: {
		backgroundImage: `url(${Banner})`,
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		// minHeight: "211px",
		padding: "20px 116px",
		marginTop: 60,
		[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
			marginTop: 0,
			padding: "40px 5px 20px 5px"
		}
	},
	titleContainer: {
		[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
			'display': 'flex',
			'width': '100%',
			'justify-content': 'space-between',
			'align-items': 'flex-start',
		}
	},
	programContainer: {
		[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
			maxWidth: '50%',
			position: 'relative'
		},

		'& > .underline': {
			position: 'absolute',
			'width': '56px',
			'height': '4px',
			'background': theme.palette.KenColors.statusYellow,
			[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
				'top': '100%',
				'right': '18px',
				'left': 'unset',
			}
		},
	},
	program: {
		'font-style': 'normal',
		'font-weight': '600',
		'font-size': theme.spacing(4),
		'line-height': '100%',
		'text-transform': 'uppercase',
		'color': '#F8F8F8',
		position: 'relative',

		[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
			'padding': '0px !important',
			'font-style': 'normal',
			'font-weight': '500',
			'font-size': '16px',
			'line-height': '100%',
			'display': 'flex',
			'align-items': 'center',
			'white-space': 'normal',
			'text-align': 'right',
			marginRight: theme.spacing(2.25)
		},

		'& > .underline': {
			position: 'absolute',
			'width': '56px',
			'height': '4px',
			top: 'calc(48px + 32px + 8px)',
			left: 0,
			'background': theme.palette.KenColors.statusYellow,
			[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
				top: 'calc(32px + 8px)',
			}
		},
	},
	details: {
		paddingTop: theme.spacing(1),
		'& > .MuiTypography-subtitle1': {
			'font-style': 'normal',
			'font-weight': '500',
			'font-size': '14px',
			'line-height': '100%',
		},
		[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
			display: 'none',
		}
	},
	nav: {
		cursor: "pointer",
		'font-style': 'normal',
		'font-weight': '400',
		'font-size': '14px',
		'line-height': '100%',
		'color': 'white',
		[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
			'white-space': 'nowrap',
		}
	},
	white: {
		color: "white",
	},
	orange: {
		color: "#E75547",
	},
	heading: {
		color: "#FFEBDA",
	},
	instituteTitle: {
		'font-style': 'normal',
		'font-weight': '400',
		'font-size': theme.spacing(3),
		'line-height': '120%',
		'text-align': 'right',
		'text-transform': 'uppercase',
		'color': 'rgba(248, 248, 248, 0.6)',
		[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
			display: 'none',
		}
	},
	instituteSubTitle: {
		'font-style': 'normal',
		'font-weight': '500',
		'font-size': theme.spacing(4),
		'line-height': '120%',
		'text-align': 'right',
		'text-transform': 'uppercase',
		'color': '#FFFFFF',
		[theme.breakpoints.down(TABLET_BREAKPOINT)]: {
			display: 'none',
		}
	}
}));

export default function KenApplicationFormHeader(props) {
	const {
		programName,
		duration,
		batch,
		endDate,
		academicYear,
		instituteName,
		title = "Admission",
	} = props;
	const classes = useStyles();
	const { hasBack } = useBack();
	const query = new URLSearchParams(useLocation().search);
	const theme = useTheme();
	const isMobileScreen = useMediaQuery(theme.breakpoints.down(
		TABLET_BREAKPOINT
	));
	const navigate = useNavigate();
	const goToDashboard = () => {
		// if (query.get("new")) {
		// 	hasBack ? navigate(-2) : navigate("/home");
		// } else {
		// 	hasBack ? navigate(-1) : navigate("/home");
		// }
		navigate("/home");
	};
	return (
		<Box className={classes.banner}>
			<Grid container spacing={0}>
				<Grid item xs={12} md={12} textAlign='left'>
					<Box className={classes.titleContainer}>
						<Link alignItems='center' sx={{ textDecoration: "none" }}>
							<Box display='flex' flexDirection='row' alignItems='center'>
								<img src={Back} alt="" />
								<Typography
									variant='subtitle1'
									style={{ color: "white" }}
									onClick={() => goToDashboard()}
									className={classes.nav}
									paddingLeft={theme.spacing(1)}
								>
									Back to Dashboard
								</Typography>
							</Box>
						</Link>

						{isMobileScreen ? <Box className={classes.programContainer}>
							<Typography
								variant='h2'
								className={`${classes.white} ${classes.program}`}
								pt={6}
								pb={2}
								noWrap
							>
								{programName}
							</Typography>
							<span className='underline'></span>
						</Box> :
							<Box
								display="flex"
								justifyContent="space-between"
								pt={6}
								pb={2}
							>
								<Box display="flex" flexDirection="column">
									<Box className={classes.programContainer}>
										<Typography
											variant='h2'
											className={`${classes.white} ${classes.program}`}

											noWrap
										>
											{programName}
											<span className='underline'></span>
										</Typography>
									</Box>
									<Box display='flex' flexDirection='row' className={classes.details}>
										{duration && (
											<Typography variant='subtitle1' className={classes.white}>
												{duration}
											</Typography>
										)}
										{duration && (
											<Typography
												variant='subtitle1'
												className={classes.white}
												margin='0px 4px'
											>
												|
											</Typography>
										)}
										<Typography variant='subtitle1' className={classes.white}>
											{batch}
										</Typography>
										{(batch || duration) && (
											<Typography
												variant='subtitle1'
												className={classes.white}
												margin='0px 4px'
											>
												|
											</Typography>
										)}
										<Typography variant='subtitle1' className={classes.white}>
											Open till: {moment(endDate).format("MMMM DD, YYYY")}
										</Typography>
									</Box>
								</Box>
								<Box display="flex" flexDirection="column">
									<Typography
										variant='h2'
										className={`${classes.instituteTitle}`}
									>
										SP Jain School
									</Typography>
									<Typography
										variant='h2'
										className={`${classes.instituteSubTitle}`}
									>
										Admissions {new Date().getFullYear()}
									</Typography>
								</Box>
							</Box>
						}
					</Box>
				</Grid>
				{/* <Grid item xs={6} md={5} textAlign='right' pt={3}>
					<Typography
						variant='subtitle4'
						className={classes.heading}
						noWrap
						component='div'
					>
						{instituteName}
					</Typography>
					<Typography
						variant='subtitle4'
						className={classes.heading}
						noWrap
						component='div'
					>
						{title}
					</Typography>
					<Typography
						variant='subtitle4'
						className={classes.heading}
						component='div'
					>
						{academicYear}
					</Typography>
				</Grid> */}
			</Grid>
		</Box>
	);
}
